<!-- TEMPLATE -->
<template>
  <div class="wrapper">
    <dean-dialog
      :title="title"
      :small="true"
    >
      <slot name="load">

      </slot>
      <dean-notification :is-modal="true">

      </dean-notification>
      <p>{{text}}</p>
      <span slot="dean-dialog-button-group">
        <dean-button :danger="true" :dialog-button="true" @click.native="close()">Nee</dean-button>
        <dean-button :success="true" :dialog-button="true" @click.native="doYesClick()">Ja</dean-button>
      </span>
    </dean-dialog>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
  import Vue from 'vue';
  import {Component, Prop} from 'vue-property-decorator';
  import axios from 'axios';
  import {
    // SVG
    warningIcon,
    // COMPONENTS
    deanDialog,
    deanDialogButtonGroup,
  } from '@deanone/dean-components';
  import deanSelectFormRow from '@/components/deanComponents/deanSelectFormRow.vue';
  import deanButton from '@/components/deanComponents/deanButton.vue';
  import DeanNotification from '@/components/deanComponents/deanNotification.vue';
  import deanFormRow from '@/components/deanComponents/deanFormRow.vue';
  import {deanDialogBus} from '@/main';

  @Component({
    components: {
      warningIcon,
      DeanNotification,
      deanDialog,
      deanButton,
      deanFormRow,
      deanSelectFormRow,
      deanDialogButtonGroup,
    },
  })

  export default class DeleteProductDialog extends Vue {
    // DATA
    @Prop() public payloadData!: {
      [key: string]: string,
    };
    public data: {[key: string]: any} = {};
    public deleting: boolean = true;

    // COMPUTED
    get title() {
      return this.deleting ? 'Product verwijderen?' : 'Product herstellen?';
    }

    get text() {
      let text = 'Weet u het zeker? Hiermee wordt product';
      text += this.deleting ? ' verwijderd.' : ' hersteld.';
      return text;
    }

    // METHODS
    public close() {
      deanDialogBus.$emit('close');
    }

    public doYesClick() {
      if (this.deleting) {
        this.deleteProduct();
      } else {
        this.undeleteProduct();
      }
    }

    public deleteProduct() {
      this.$emit('setLoad', true);
      const url = '/-/trade/api/settings.product.delete';
      axios.post(url, {id: this.payloadData.id})
        .then(
          (response: any) => {
            deanDialogBus.$emit('productStatusChange');
            this.close();
          },
          (error: any) => {
            this.$toast({
              icon: warningIcon,
              text: 'Contact kan momenteel niet worden verwijderd, probeer het later opnieuw.',
              theme: 'warning',
            });
          },
        ).finally(() => {
        this.$emit('setLoad', false);
      });
    }

    public undeleteProduct() {
      this.$emit('setLoad', true);
      const url = '/-/trade/api/settings.product.undelete';
      axios.post(url, {id: this.payloadData.id})
        .then(
          (response: any) => {
            deanDialogBus.$emit('productStatusChange');
            this.close();
          },
          (error: any) => {
            this.$toast({
              icon: warningIcon,
              text: 'Contact kan momenteel niet worden hersteld, probeer het later opnieuw.',
              theme: 'warning',
            });
          },
        ).finally(() => {
        this.$emit('setLoad', false);
      });
    }

    public created() {
      this.deleting = (this.payloadData.state !== 'restoring');
    }

    public destroyed() {
      this.$emit('setLoad', false);
    }
  }
</script>

<!-- STYLE -->
<style lang="scss" scoped>
  // IMPORT
  @import '~@deanone/dean-components/src/scss/vars';
</style>